export default "__VITE_ASSET__eeNB8CXd__";